import React from 'react';
import { ListButton, SaveButton, Toolbar, useDataProvider, useNotify, useRedirect } from 'react-admin';
import { Prize } from '../../types/prize';
import "./index.css"
import { useSelector } from "react-redux";
import { checkDiscountPreviousValue, checkDiscountValues, checkFillDiscount, checkFillDiscountRates, checkIsCash } from '../../helpers/checkDiscount';
import { TicketRatesDiscount } from '../../types/property';
import { CreditProps } from '../common/generalPickersBlocks/credits/CreditsPickerComponent';
import { checkCreditsDateError } from '../../helpers/checkDreamHome';
import { checkIsOverviewPropRowValid } from '../dreamHome/shared/overview/PropertyRow';

const PrizeToolbar = (props, isCreate: boolean, overview, setOverviewError, handleImagesError, discountFillError, setIsDiscountValidate,creditsData: {
    creditsArr: Array<CreditProps>;
    dateType: string;
    creditsStatus: boolean;
    creditsStartDate: Date | string | undefined;
    creditsEndDate: Date | string | undefined;
  }) => {
    const notify = useNotify()
    const redirect = useRedirect();
    const stateApp = useSelector((state) => state);
    const dataProvider = useDataProvider();

    const location = props.location.pathname.split('/')
    const path = location[location.length - 1] === "1" ? "1" : "";
    const id = props.id ? props.id + '/' : 'create/'


    const handleSave = async (data) => {
        const images = stateApp.property.galleryFiles
        const imagesMobile = stateApp.property.galleryFilesMobile
        if (stateApp.property.isNew) {
            isCreate = true
        }
        if (!images.length) {
            handleImagesError(true)
            notify("The form in not valid. Please check for errors", "error");
            return
        }
        if (path === "") {
            redirect(`/prizes/${id}1`)
            return
        }
        if (!data.ticketPrice || !data.defaultTickets) {
            setIsDiscountValidate(true)
            notify("The form in not valid. Please check for errors", "error");
            return
        }

        if (!(checkIsOverviewPropRowValid(overview,false))) {
            setOverviewError(true)
            notify("The form is not valid. Please check for errors", "error");
            return;
        }
        const discountTicket = stateApp.property.ticketDiscount
        const category = await dataProvider.getOne('prizeCategories', { id: data.prizeCategory }) as any;
        if (category.data.subCategory.length === 0) {
            data.subCategory = undefined
        }
        let prize: Prize = {
            discountCategory: data.discountCategory,
            description: data.description,
            defaultTickets: data.defaultTickets,
            price: data.price,
            ticketPrice: parseFloat(data.ticketPrice.toFixed(2)),
            title: data.title.replace(/\s+/g, ' ').trim(),
            subtitle:data.subtitle,
            isActiveDiscount: data.isActiveDiscount || false,
            active: data.active || false,
            subCategory: data.subCategory,
            prizeCategory: data.prizeCategory,
            id: data.id || '',
            photoUrlKeys: [],
            photoUrlKeysMobile:[],
            discountTicket: data.isActiveDiscount ? discountTicket : { percent: 1, newPrice: 1 },
            discountRates: data.isDiscountRates ? stateApp.property.discountRates : Array<TicketRatesDiscount>(),
            isTrending: data.isTrending || false,
            isPopular: data.isPopular || false,
            isDiscountRates: data.isDiscountRates || false,
            creditsRates:creditsData.creditsArr,
            isCreditsActive:creditsData.creditsStatus,
            creditsStartDate:creditsData.creditsStartDate,
            creditsEndDate:creditsData.creditsEndDate,
            isCreditsPermanent: creditsData.dateType === "allDate" ? true : false,
            overview:overview,
            metaTitle: data.metaTitle,
            metaDescription: data.metaDescription
        }
        const isDiscountFillError = checkFillDiscount(prize.isActiveDiscount, prize.discountTicket)
        const isDiscountRatesFillError = checkFillDiscountRates(prize.isDiscountRates, prize.discountRates)
        const isPreviousValueError = checkDiscountPreviousValue(prize.discountRates)
        const isDiscountValueError = checkDiscountValues(prize.discountCategory, prize.discountRates)
        const isCreditsDateError = prize.isCreditsPermanent?false:checkCreditsDateError(prize)
        if (isDiscountRatesFillError || isPreviousValueError || isDiscountValueError || isDiscountFillError ||isCreditsDateError) {
            discountFillError(true)
            notify("The form in not valid. Please check for errors", "error");
            return
        }
        prize.discountRates = prize.isDiscountRates ? checkIsCash(data.discountCategory, stateApp.property.discountRates) : Array<TicketRatesDiscount>()
        const newPrize = isCreate ?
            await dataProvider.create("prizes", {
                data: prize,
            }) :
            await dataProvider.update("prizes", {
                data: prize,
                id: props.id,
                previousData: {} as any
            });
        if (!newPrize.data) {
            notify("something went wrong", "error")
        }
        const result = await dataProvider.storeImages({ source: "prizes", id: newPrize.data.result._id }, {images,imagesMobile})

        await dataProvider.updateMostPopular({competitionType:"PRIZE", id:newPrize.data.result._id, title:newPrize.data.result.title });
        if (newPrize.data.result.active && newPrize.data.result.isTrending) {
            await dataProvider.addFeatured("PRIZE",newPrize.data.result._id)
        } else {
            await dataProvider.removeFeatured("PRIZE",newPrize.data.result._id)
        }
        if (!result.data) {
            notify("something went wrong", "error")
        }
        notify(`Prize ${isCreate ? 'saved' : 'updated'}`);
        redirect("/prizes");
    }

    return (
        <Toolbar {...props} className="buttons-wrapper">
            <SaveButton className="save-button" onSave={handleSave} />
            <ListButton className="cancel-button" label="Cancel"><div>Cancel</div></ListButton>
        </Toolbar>
    )
}

export default PrizeToolbar

